'use client';

import React, { useState } from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { useTranslation } from 'react-i18next';
import PlusIcon from '../atoms/icons/plus';
import UtilityButton from '../buttons/utilityButton';

const HotelFacilities = ({ blok, hotel }) => {
  const { t } = useTranslation(['hotel']);

  const [showAll, setShowAll] = useState(false);
  const toggleShowAll = () => setShowAll(!showAll);

  return (
    <div
      className="col-span-12 mt-12 px-4 md:px-8"
      {...storyblokEditable(blok)}
      key={blok._uid}
    >
      <div className="w-full max-w-screen-xl mx-auto">
        <h2 className="text-xl">{t('Hotel facilities')}</h2>
      </div>

      <ul className="w-full max-w-screen-xl mx-auto mt-4 px-0 grid gap-x-16 gap-y-0 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {hotel.distanceToLift !== null && (
          <HotelFacility
            facility={t('Distance to lift')}
            value={`${hotel.distanceToLift} m`}
          />
        )}
        {hotel.distanceToTownCentre !== null && (
          <HotelFacility
            facility={t('Distance to town centre')}
            value={`${hotel.distanceToTownCentre} m`}
          />
        )}
        {hotel.distanceToSkibus !== null && (
          <HotelFacility
            facility={t('Distance to skibus')}
            value={`${hotel.distanceToSkibus} m`}
          />
        )}

        {hotel.facilities.map(
          (f, index) =>
            f.descriptions &&
            f.descriptions.length > 0 && (
              <HotelFacility
                facility={f.descriptions[0].value}
                value={t('Yes')}
                key={f.id}
                show={index < 3 || showAll}
              />
            ),
        )}
      </ul>
      {hotel.facilities.length > 3 && (
        <div className="w-full flex justify-end items-center py-4">
          {showAll && (
            <UtilityButton
              label={t('Show less')}
              onClick={toggleShowAll}
              icon={<PlusIcon inverted={true} />}
            />
          )}
          {!showAll && (
            <UtilityButton
              label={t('Show all')}
              onClick={toggleShowAll}
              icon={<PlusIcon inverted={false} />}
            />
          )}
        </div>
      )}
    </div>
  );
};

const HotelFacility = ({ facility, value, id, show = true }) => (
  <li
    className={`py-4 px-0 border-b-[1px] border-black-12.5 flex justify-between ${
      show ? '' : 'hidden '
    }`}
    key={id}
  >
    <span className="font-bold">{facility}</span>
    <span className="">{value}</span>
  </li>
);

export default HotelFacilities;
